import {
  observable,
  action
} from 'mobx'
import FileSaver from "file-saver";
import utils from "@foxit/utils";
import { message } from 'antd';
import {store} from '../store.index';
import getStream from './getStream';
import { docs, jobs, jobsStatus } from "../../api/fwApi/pdf365";
import {isMobile} from 'Utils/device';

class addCoverPage extends getStream {
  @observable pdfUi = window.pdfui;
  @observable docsId = null;
  @observable docsKey = null;
  @observable saveType = null;
  @observable addCoverOpenFile = false;
  @observable printOk = false; // 用于标识打印方式，不算做修改。
  @observable printTrue = false;
  @observable filePassword = "";
  @observable saveFilesOk = false;
  

  @action setDocsId(docsId) {
    this.docsId = docsId
  }
  @action setDocsKey(docsKey) {
    this.docsKey = docsKey
  }
  @action setSaveType(saveType) {
    this.saveType = saveType
  }
  @action setAddCoverOpenFile(addCoverOpenFile) {
    this.addCoverOpenFile = addCoverOpenFile
  }
  @action setPrintOk(printOk) {
    this.printOk = printOk
  }
  @action setPrintTrue(printTrue) {
    this.printTrue = printTrue
  }

  // !uploadFile 添加封面页的文件上传服务器
  @action uploadFile(blob, saveType) {
    store.common.setIsShowMeeting(true) // !显示loading
    store.appStore.doUpdateDocModified(false);
    this.setSaveType(saveType)
    let formData = new FormData();
    formData.append("file", blob);
    const config = {
      withCredentials: false,
      headers: {
        "Content-Type": "multipart/form-data;boundary = " + new Date().getTime()
      },
      formData
    };
    docs(formData, config).then(
      res => {
        if (res.code === "SUCCESS") {
          this.setDocsId(res.data.id)
          this.setDocsKey(res.data.key)
          this.jobs(res.data.id);
        }
      },
      err => {
        store.common.setIsShowMeeting(false)
        console.log(err);
      }
    ).catch(() => {
      store.common.setIsShowMeeting(false)
    });
  }
  @action getUserPassword () {
    const pdfDoc = window.pdfui.pdfViewer.currentPDFDoc
    return new Promise(resolve => {
      console.log(pdfDoc.hasOwnerPassword)
      // if (pdfDoc.hasOwnerPassword) {
        //   this.requestOwnerPassword(window.pdfui, (ownerPassword) => {
        //       console.log(ownerPassword)
        //       pdfDoc.getUserPassword(ownerPassword).then((userPassword) => {
        //           uiData.userPassword = userPassword;
        //       });
        //   });
        // } else {
        pdfDoc.getUserPassword('').then((userPassword) => {
          console.log(userPassword)
          resolve(userPassword)
        });
      // }
    })
  }
  // ! [jobs 创建封面页任务
  @action async jobs(id) {
    let password = ""
    password = window.sessionStorage.getItem("cachePageNewPassword")
    if(password) {
      window.sessionStorage.removeItem("cachePageNewPassword")
    } else {
      password = await this.getUserPassword()
    }
    this.filePassword = password
    const { isBusinessUser } = store.userNewStore
    const params = [
      {
        id,
        password: password,
        data: {
          cover: isBusinessUser ? 1 : 0 // ! 1:企业账户保存封面为云编辑；0：非企业用户:，封面为云办公；
        }
      }
    ];
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    };
    jobs(JSON.stringify(params), config).then(
      res => {
        if (res.code === "SUCCESS") {
          this.jobsStatus(res.data.id);
        }
      },
      err => {
        store.common.setIsShowMeeting(false)
        console.log(err);
      }
    ).catch(() => {
      store.common.setIsShowMeeting(false)
    });
  }
  // ! jobsStatus 查询封面页任务
  @action jobsStatus(id) {
    const config = {
      banClearLoading: true,
      params: {
        id
      }
    };
    jobsStatus(config).then(
      res => {
        if (res.code === "SUCCESS") {
          if (res.data.docStateMap[id] === 10009) {
            this.$vue.$toast("密码错误！");
          } else if (res.data.state === "FINISH") {
            console.log("FINISH")
            this.openFile();
          } else {
            setTimeout(() => {
              this.jobsStatus(id);
            }, 3000);
          }
        }
      },
      err => {
        store.common.setIsShowMeeting(false)
        console.log(err);
      }
    ).catch(() => {
      store.common.setIsShowMeeting(false)
    });
  }
  // ! 打开添加封面页文件
  @action async openFile() {
    this.saveFilesOk = true
    const pdfDoc = await window.pdfui.getCurrentPDFDoc()
    let fileUrl = `https://api.pdf365.cn/api/v2/docs/target?id=${this.docsId}&key=${this.docsKey}&actual=true`;
    // debugger
    // TODO FOXIT 监控平台——err:
    pdfDoc && pdfDoc.getPasswordType().then(type => {
      if (type === 1 || type === 2) {
        // 无密码
        this.setAddCoverOpenFile(true)
        this.pdfUi.openPDFByHttpRangeRequest(
          {
            range: {
              url: fileUrl
            }
          },
          { fileName: pdfDoc.info.fileName }
        );
      } else if (type === 3) {
        // 有密码
        this.setAddCoverOpenFile(true)
        this.pdfUi.openPDFByHttpRangeRequest(
          {
            range: {
              url: fileUrl
            }
          },
          {
            fileName: pdfDoc.info.fileName,
            password: this.filePassword  // pdfDoc.parameters.password
          }
        );
      }
      let saveType = store.saveFileNewStore.saveType
      // ！云文档的保存不在走这块逻辑
      // if (saveType === "cloudDoc") { 
      //   store.common.urlToBlob(fileUrl);
      //   store.common.setIsShowMeeting(false)
      // } else 
      if (saveType === "print") {
        store.common.setIsShowMeeting(false)
        this.openPrint()
      } else {
        utils.util.urlToBlob(fileUrl).then(async blob => {
          if(saveType === 'cloudDocs'){
            try {
              const isFree = true;
              const fileName = this.fileNameToPDF(pdfDoc.info.fileName)
              const uploadRes = await store.docsStore.uploadDocument(blob, fileName, store.docsStore.docsCurrentFolderId, isFree);
              if(uploadRes.code === 0){
                store.docsStore.getIsSaveSuccess(true);
                message.success('保存成功');
                if(isMobile) {
                  store.docsStore.getShowMobileDocs(false)
                }
                try {
                  const getFindDocFolderRes = await store.docsStore.getFindDocFolder(store.docsStore.docsCurrentFolderId)
                  if(getFindDocFolderRes.code === 0){
                    store.docsStore.getDocsFolderData(getFindDocFolderRes.data?getFindDocFolderRes.data:[])
                    try {
                      let getFindDocFileRes = await store.docsStore.getFindDocFile(store.docsStore.docsCurrentFolderId)
                      if(getFindDocFileRes.code === 0){
                        const filterFileData = getFindDocFileRes.data.records?getFindDocFileRes.data.records:[].filter(item=>{
                          return item.extName === 'pdf'
                        })
                        store.docsStore.getFilterDocsFileData(filterFileData);
                        store.docsStore.getIsSetListSuccess(true);
                      }
                    } catch (error) {
                      console.log(error)
                    }
                  }
                } catch (error) {
                  console.log(error)
                }
              }
            } catch (error) {
              console.log(error)
            }
          } else {
            const fileName = this.fileNameToPDF(pdfDoc.info.fileName)
            console.log(blob)
            // 处理ios手机端的vip保存 调用 download-file-button handle（）
            // if(isMobile) {
            if(store.fwMobileViewStore.isIOS) {
              store.common.setIsShowMeeting(false)
              window.pdfui.addViewerEventListener("open-file-success", function() {
                window.pdfui.getComponentByName("download-file-button").then(compByName => {
                  if (this.saveFilesOk) {
                    compByName.controller.handle()
                    this.saveFilesOk = false
                  }
                })
              })
              return
            }
            const u = navigator.userAgent;
            const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
            if(isAndroid) {
              store.common.setIsShowMeeting(false)
              window.pdfui.addViewerEventListener("open-file-success", () => {
                if (this.saveFilesOk) {
                  this.saveFilesOk = false
                  this.getFileBlob().then(blob => {
                    FileSaver(blob, fileName);
                  })
                }
              })
              return
            }
            FileSaver(blob, fileName);
          }
          store.common.setIsShowMeeting(false)
        });
      }
    }).catch(() => {
      store.common.setIsShowMeeting(false)
    });
  }
  

  @observable fileName = null
  // 保存
  @action setFileName(fileName) {
    this.fileName = fileName
  }
  // 获取pdf文本流
  @action async getFileBlob() {
    const pdfDoc = await window.pdfui.getCurrentPDFDoc();
    this.setFileName(pdfDoc.info.fileName)
    let bufferArray = [];
    return pdfDoc.getStream(({ arrayBuffer}) => {
      bufferArray.push(arrayBuffer);
    })
    .then((size) => {
      console.log("The total size of the stream", size);
      return new Blob(bufferArray, { type: "application/pdf" });
    });
  }
  // openPrint 用于触发打印按钮，这里触发太快了，要在文档打开后触发,
  // ! 打开当前保存封面的文档后,每次打开新的文档都会触发
  @action fileNameToPDF(fileName) {
    let name = fileName
    let arr = fileName.split(".")
    if(arr[arr.length-1] !== "pdf") {
      arr[arr.length-1] = "pdf"
      name = Array.join(arr, ".")
    }
    return name
  }
  @action async openPrint() {
    this.setPrintTrue(true)
    let Events = UIExtension.PDFViewCtrl.Events;
    pdfui.addViewerEventListener(Events.openFileSuccess, async () => {
      if(this.printTrue) {
        if (isMobile) {
          store.fwMobileViewStore.mobilePrintFunction()
        } else {
          let printButton =  await window.pdfui.getComponentByName('print-button')
          printButton.controller.handle()
        }
        this.setPrintTrue(false)
      }
    })
  } 
}

export default addCoverPage;